import axios from "axios";
import { getBackendUrl } from "@/general";


export const getServerName = async () => {
  try {
    // await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/getServidor`
    )

    return res.data;
  } catch (err) {
    console.log(err);
    throw err.response;
  }
}

export const descargaArchivoS3 = async (context, filters) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl()
    const res = await axios.get(
      `${source}/consultas/api/descargaArchivo`,
      {
        params: filters,
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data;
  } catch (err) {
    console.log(err);
    throw err.response;
  }
}


export const datosAdquiriente = async (context, filters) => {
  try {
    await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}/consultas/api/datosAdquiriente/`,
      {
        params: filters,
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    )

    return res.data;
  } catch (err) {
    console.log(err);
    throw err.response;
  }
}
